import ChartPDFDateFormattingStrategy from './ChartPDFDateFormattingStrategy'
import messageResource from '../../messageResource'
import DateRangeFormattingStrategy from '../../parametersFormatting/DateRangeFormattingStrategy'

export default class ChartPDFDateRangeFormattingStrategy extends ChartPDFDateFormattingStrategy {
    constructor(dateFormat, dateFormatForFileName) {
        super(dateFormat, dateFormatForFileName)

        this.previewDateFormatStrategy = new DateRangeFormattingStrategy(dateFormat) // for use methods from lightbox preview header formatter
    }

    formatDateInformation(dateParameters) {
        return this.previewDateFormatStrategy.formatForDateInformation(dateParameters)
               + " "
               + this.previewDateFormatStrategy.formatSpecifyingInformation(dateParameters)
    }

    formatDateForFileName(dateParameters) {
        const dateRangeSelection = dateParameters.dateRangeSelection
        return messageResource.getMessage('common.pdf.formatting.file_name_date_range_template',
            [
                this.formatFileNameDate(dateRangeSelection.fromDate),
                this.formatFileNameDate(dateRangeSelection.toDate)
            ]
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/pdf/formatters/ChartPDFDateRangeFormattingStrategy.js